export default __webpack_public_path__ + "static/media/icon-home-3.e39cff3a.svg";